import {ModalFooter, ModalHeader} from "@heroui/modal";
import {Button} from "@heroui/button";
import React from "react";
import {OutlineFolder} from "@/components/icons";

export function ChooseFileLocationPopup({onAccept}) {
    return (
        <>
            <ModalHeader className="flex flex-col gap-1">
                <span id="modal-title">
                    Choose where to save your file
                </span>
            </ModalHeader>
            <ModalFooter>
                <Button fullWidth onPress={() => onAccept?.()} color="primary"
                        startContent={<OutlineFolder width={"20px"} height={"20px"}/>}>
                    Choose file location
                </Button>
            </ModalFooter>
        </>
    );
}
